import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";

export default function Nav() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <header className="sticky top-0 z-50 border-b border-white/10 bg-black/70 backdrop-blur-2xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <div className="h-6 w-6 rotate-45 border border-[#E5FF00] bg-[#E5FF00]/10"></div>
          <span className="font-display text-lg font-medium tracking-tight">OBSIDIAN</span>
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">/ v1</span>
        </Link>
        <nav className="hidden gap-8 md:flex">
          <Link to="/pricing" data-testid="nav-pricing" className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400 hover:text-white transition-colors">Pricing</Link>
          {user && <Link to="/dashboard" data-testid="nav-dashboard" className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400 hover:text-white transition-colors">Dashboard</Link>}
          {user && <Link to="/scan" data-testid="nav-scan" className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-400 hover:text-white transition-colors">Run Scan</Link>}
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <>
              <span className="hidden font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 md:inline">{user.email}</span>
              <Button data-testid="nav-logout" variant="outline" size="sm" onClick={() => { logout(); nav("/"); }}
                className="btn-cta rounded-none border-white/20 bg-transparent font-mono text-[11px] uppercase tracking-[0.2em] hover:border-[#E5FF00] hover:text-[#E5FF00]">
                Logout
              </Button>
            </>
          ) : (
            <>
              <Button data-testid="nav-login" variant="ghost" size="sm" onClick={() => nav("/login")}
                className="rounded-none font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-400 hover:text-white hover:bg-transparent">
                Login
              </Button>
              <Button data-testid="nav-signup" size="sm" onClick={() => nav("/signup")}
                className="btn-cta rounded-none border border-[#E5FF00] bg-transparent font-mono text-[11px] uppercase tracking-[0.2em] text-[#E5FF00] hover:bg-[#E5FF00] hover:text-black">
                Start scan →
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
